"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.create.title': 'Create Tutorial',
    'tutorial.create.button': 'Create Tutorial',
};
